import { Form, Input, Modal, message } from 'antd';
import axios from 'axios';
import { useState } from 'react';

import { BRAND_NAME_MAX_LENGTH, brandNameRules, trimTextFields } from '../../utils/formRules';
import useBrandStore from './brandStore';

const CreateBrand = ({ visible, onCancel }) => {
  const [form] = Form.useForm();
  const refreshBrandList = useBrandStore((state) => state.refreshBrandList);
  const [saving, setSaving] = useState(false);

  const submitCreateBrand = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch {
      return;
    }

    /**
     * Толгой/сүүлийн зайг тайрч хадгална — эс тэгвээс " Nike " ба "Nike" хоёр
     * өөр нэр гэж тооцогдож, сервер талын давхардлын шалгалт тойрогдоно.
     */
    const payload = { ...values, ...trimTextFields(values, ['name']) };

    setSaving(true);
    try {
      const { data } = await axios.post('/api/v1.0/productgroup', payload);

      // Backend нь алдааг ч HTTP 200-аар буцаадаг тул биед байгаа statusCode-оор шалгана
      if (data?.statusCode !== 200) return;

      message.success('Брэнд амжилттай нэмэгдлээ.');
      refreshBrandList();
      onCancel();
    } catch (e) {
      console.error('Create Brand: ', e);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title="Брэнд нэмэх"
      open={visible}
      onCancel={onCancel}
      onOk={submitCreateBrand}
      okText="Хадгалах"
      cancelText="Буцах"
      confirmLoading={saving}
      maskClosable={false}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item label="Брэнд" name="name" rules={brandNameRules()}>
          <Input placeholder="Брэндийн нэр" maxLength={BRAND_NAME_MAX_LENGTH} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateBrand;
